import React from 'react';
import { type ProfessionalQualificationFormsProps } from './types';
import { ProfessionalQualificationForm } from './ProfessionalQualificationForm';
import { PAGE_COMMON_TEXT } from '../../lang';

export const ProfessionalQualificationForms: React.FunctionComponent<
  ProfessionalQualificationFormsProps
> = (props: ProfessionalQualificationFormsProps) => {
  const professionalQualifications = props.data ?? [];
  const hasProfessionalQualifications = professionalQualifications.length > 0;

  return hasProfessionalQualifications ? (
    <div>
      {professionalQualifications.map((professionalQualification, index) => (
        <ProfessionalQualificationForm
          key={index}
          professionalQualificationIndex={index}
          professionalQualificationData={professionalQualification}
        />
      ))}
    </div>
  ) : (
    <div>{PAGE_COMMON_TEXT.NA}</div>
  );
};
